import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0d0685ce"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d0685ce')) {
      api.createRecord('0d0685ce', component.options)
    } else {
      api.reload('0d0685ce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0d0685ce", function () {
      api.rerender('0d0685ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/faq/index.vue"
export default component.exports